/** Languages a server can pick for its transcripts (whisper codes). 24 plus auto: Discord allows 25 choices. */
export const TRANSCRIPT_LANGUAGES = [
  { code: 'auto', name: 'Detect automatically' },
  { code: 'en', name: 'English' },
  { code: 'he', name: 'Hebrew' },
  { code: 'ar', name: 'Arabic' },
  { code: 'ru', name: 'Russian' },
  { code: 'uk', name: 'Ukrainian' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'it', name: 'Italian' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'nl', name: 'Dutch' },
  { code: 'pl', name: 'Polish' },
  { code: 'tr', name: 'Turkish' },
  { code: 'ro', name: 'Romanian' },
  { code: 'el', name: 'Greek' },
  { code: 'sv', name: 'Swedish' },
  { code: 'fa', name: 'Persian' },
  { code: 'hi', name: 'Hindi' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'zh', name: 'Chinese' },
  { code: 'id', name: 'Indonesian' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'th', name: 'Thai' },
] as const;

export type TranscriptLanguage = (typeof TRANSCRIPT_LANGUAGES)[number]['code'];

export const TRANSCRIPT_LANGUAGE_CODES = TRANSCRIPT_LANGUAGES.map((l) => l.code) as [TranscriptLanguage, ...TranscriptLanguage[]];

export function languageName(code: string | null): string {
  return TRANSCRIPT_LANGUAGES.find((l) => l.code === code)?.name ?? code ?? 'Detect automatically';
}
